// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pdaPrmClass[data-v-f4b94a9a]  .el-form-item__label {\n  line-height: 20px;\n}\n.custom-tree-node[data-v-f4b94a9a] {\n  font-size: 18px;\n}\n.custom-tree-node .custom-tree-node-btn[data-v-f4b94a9a] {\n  margin-left: 10px;\n}\n.app-container.pda .iconfont[data-v-f4b94a9a] {\n  font-size: 20px;\n  font-family: element-icons !important;\n}\n.titlts[data-v-f4b94a9a] {\n  display: inline-block;\n  min-width: 120px;\n}", ""]);
// Exports
module.exports = exports;
